<script setup lang="ts">
/** `<LucideIcon>` — yalnızca DİNAMİK (data-driven) ikonlar için. */
import {computed, getCurrentInstance} from 'vue'
import {lucideIconMap} from '@shared/icons/lucide'

defineOptions({name: 'LucideIcon'})

const props = defineProps<{
  icon: string | [string, string]
  spin?: boolean
  size?: string | number
}>()

const BRAND_IMG: Record<string, string> = {
  jira: 'integrations/jira.svg',
  youtube: 'integrations/youtube.svg',
}

// $image global helper'ı (main.ts) — script tarafında instance proxy üzerinden.
const $image = (getCurrentInstance()?.proxy as unknown as {
  $image?: (url: string) => string
})?.$image

const iconName = computed<string>(() =>
  Array.isArray(props.icon) ? props.icon[1] : props.icon,
)
const lucideComponent = computed(() => lucideIconMap[iconName.value])
const brandSrc = computed<string>(() => {
  const rel = BRAND_IMG[iconName.value]
  return rel ? ($image?.(`assets/${rel}`) ?? '') : ''
})

const FA_SIZE_EM: Record<string, string> = {
  '2xs': '0.625em', 'xs': '0.75em', 'sm': '0.875em', '1x': '1em',
  'lg': '1.25em', 'xl': '1.5em', '2xl': '2em', '2x': '2em',
  '3x': '3em', '4x': '4em', '5x': '5em', '6x': '6em',
}
const sizeValue = computed<string>(() => {
  if (props.size == null) return '1em'
  return typeof props.size === 'number'
    ? `${props.size}px`
    : (FA_SIZE_EM[props.size] ?? props.size)
})
const lucideStyle = computed<Record<string, string> | undefined>(() =>
  props.size == null ? undefined : {width: sizeValue.value, height: sizeValue.value},
)
</script>

<template>
  <img
    v-if="brandSrc"
    :src="brandSrc"
    :style="{height: sizeValue, width: 'auto'}"
    :class="{'lucide-spin': spin}"
    alt=""
    aria-hidden="true"
  />
  <component
    :is="lucideComponent"
    v-else-if="lucideComponent"
    :style="lucideStyle"
    :class="{'lucide-spin': spin}"
    aria-hidden="true"
  />
</template>
